export default __webpack_public_path__ + "static/media/skipG.d0dc1da2.png";